import React from 'react';
import ContentLoader from 'react-content-loader';
import { GRAPH_HEIGHT } from 'src/constants/portfolio';

// Made using https://skeletonreact.com/
function PortfolioGraphSkeleton() {
  return (
    <ContentLoader
      style={{
        borderRadius: 4,
      }}
      speed={2}
      width="100%"
      viewBox={`0 0 974 ${GRAPH_HEIGHT}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect width="100%" height="100%" />
    </ContentLoader>
  );
}

export default PortfolioGraphSkeleton;
